const appModal = document.getElementById('app-modal')  
const appModalBS =  new bootstrap.Modal(appModal);
const appModalData = document.querySelector('.app-modal-data');


function showModal({        
    url='', 
    showSave= true,
    showClose = false,
    showsecondaryBtn = false,
    saveText= 'Save',
    closeText= 'Close',
    title='Title',
    size = 'modal-lg',
    secondaryBtnText = '',
    secondaryBtnURL='',
    width='',
    callback = null }) 
{

    Page_Blur(true);
    var $modalTemplate = $('#modal-template');
    var $modal = $modalTemplate.find("#app-modal").clone().addClass("real-modal").removeAttr('id').appendTo('body');
    var uniqueId = 'modal_' + Math.random().toString(36).substr(2, 9);
    $modal.attr('id', uniqueId);

    if (width!= "") {
        $modal.find(".modal-content").css("width", width);
    }

    var removeModal = function () {
        console.log ('close modal');
         //$(".real-modal").remove();
           $modal.remove();
                 //$('.modal-backdrop').hide();         
        //$('body').removeClass('modal-open');
      // $(".real-modal").remove();      
       
       //$modal.attr('id', uniqueId);
    };

    $modal.find('.app-modal-data').empty();  //clear anything there
    $modal.find(".modal-footer").hide();
    if (showSave && saveText!=""){
        $modal.find(".modal-footer").show();
        $modal.find('#app-modal-save').text(saveText).on('click', function () {
            callback($modal); // Pass modal instance to callback
        });
    } else { $modal.find("#app-modal-save").hide() }

    if (showClose && closeText !="") {
        $modal.find(".modal-footer").show();
        $modal.find("#app-modal-close").show().html( closeText) 
    } else { $modal.find("#app-modal-close").hide() }

    if (showsecondaryBtn && secondaryBtnText != "" && secondaryBtnURL!="") {
        $modal.find(".modal-footer").show();
        $modal.find('#app-modal-secondaryBtn').text(secondaryBtnText).on('click', function () {
            window.open(secondaryBtnURL, '_blank'); // Pass modal instance to callback
        });
    } else { $modal.find("#app-modal-secondaryBtn").hide() }

    $modal.find("#app-modal-label").html( title)
    
    $modal.removeClass('modal-lg').removeClass('modal-xl').removeClass('modal-sm').addClass(size);    

    $.get(url, { cache: false })
        .done(function (data) { 
            $modal.find('.app-modal-data').html(data);            
            $modal.modal('show');
        })
        .fail(function (xhr, status, error) {            
            console.error("Error loading modal content:", error);           
        });

    $modal.on('shown.bs.modal', function () { 
        setEditClean ();
        Page_Blur(false);
    });


     $modal.on('hide.bs.modal', function () {
    
        if (bEditDirty){
            if (!window.confirm('You have unsaved changes. Are you sure you want to close this window?')) {
                return false;
            }
        }
        updateSearchChecks()
        setEditClean()
    });

    $modal.on('hidden.bs.modal', function () {      
       removeModal()
    });

}

function closeModal(modal) {
   
    //removeModal()
    $(modal).modal('hide');        
   // $(".real-modal").remove();
  //  $(modal).remove();
}



 function showLoginNotification(msg) {
    Page_Blur(false); 
    $(".toast-body").html(msg);
    myToast.show();
}

function showSystemNotification(msg) {
    Page_Blur(false); 
    $(".toast-body").html(msg);
    myToast.show();
}

function showSupportNotification(msg) {
    showSystemNotification(msg + " Please contact Customer Care.")
}


var myToast
$(function () {

    var myToastEl = document.getElementById('liveToast')
    myToast = bootstrap.Toast.getOrCreateInstance(myToastEl) // Returns a Bootstrap toast instance

});


    

function showLoginMessage(url) {
    
   // alert(url);
    //new overlayModuleTrips().showOverlay(url, false)
}
function showAccountMessage(url) { //new overlayModuleTrips().showOverlayLeft(url, false) 
}
function showSiteNotice(url) {
	//url = "/widgets/user/sitenotice.aspx?u=" + escape(url)
	//var h = ($(window).height()) * .8; var w = ($(window).width()) * .8;
	//if (w > 900) { w = 900 }
	//if (h > 700) { h = 700 }
 //   $.fancybox(
	//		{  'href': url,margin: 0, padding: 0,autoDimensions:false, width:w, height:h, 'transitionIn': 'elastic',
 //       'speedIn': 200

	//		})

}

function showSiteNotice2(url) {
   // url = "/widgets/user/sitenotice.aspx?u=" + escape(url)

   // $.fancybox(
			//{
			//    'href': url, margin: 0, padding: 0, autoDimensions: true, 'transitionIn': 'elastic',
			//    'speedIn': 200

			//})
}


function showSiteNoticeIFrame(url) {
//    if  ($(window).width() >480){
//    $.fancybox(
//			{
//			    'type': 'iframe', 'href': url, 'width': 445, 'height':450, 'transitionIn': 'elastic', 'speedIn':200, 'transitionOut': 'none', 'scrolling': 'false', 'margin': [0, 0, 0, 0], 'padding': 0, 'hideOnOverlayClick': false
//			})
//}
}


